import { render } from "./SimpleNoteDetailOperationCard.vue?vue&type=template&id=c5a3812e&scoped=true"
import script from "./SimpleNoteDetailOperationCard.vue?vue&type=script&lang=js"
export * from "./SimpleNoteDetailOperationCard.vue?vue&type=script&lang=js"

import "./SimpleNoteDetailOperationCard.vue?vue&type=style&index=0&id=c5a3812e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5a3812e"]])

export default __exports__